export const environment = {
  production: false,
  apiBase:
    'https://titwmo9dek.execute-api.ap-southeast-2.amazonaws.com/tempAccom/booking/',
};
